export default __webpack_public_path__ + "static/ShareSection3_it-81029717f5bede7a75bc1ee30c02a4ed.png";